// extracted by mini-css-extract-plugin
export var contentPage = "styles-module--content-page--c229b";
export var loginPage = "styles-module--login-page--23e5e";
export var markdownPage = "styles-module--markdown-page--a532f";
export var pageContent = "styles-module--page-content--4ad3a";
export var pageWrapper = "styles-module--page-wrapper--d2fd4";
export var postPage = "styles-module--post-page--86596";
export var saladPage = "styles-module--salad-page--d2211";
export var sandboxPage = "styles-module--sandbox-page--8e20a";